import { useCallback, useState } from 'react';

const useResultsTableFilters = () => {
  const [globalFilter, setGlobalFilter] = useState('');
  const [columnFilters, setColumnFilters] = useState([]);
  const [quickFilters, setQuickFilters] = useState({
    dealerName: '',
    programLabel: '',
    stateOrProvince: '',
  });
  const [selectedBrandCodes, setSelectedBrandCodes] = useState([]);

  const handleQuickFilterChange = useCallback((id, value) => {
    setQuickFilters((prev) => ({ ...(prev || {}), [id]: value }));
    setColumnFilters((prev) => {
      const next = (prev || []).filter((item) => item.id !== id);
      const normalized = value?.toString?.() ?? '';
      if (normalized.trim()) {
        next.push({ id, value: normalized });
      }
      return next;
    });
  }, []);

  const resetFilters = useCallback(() => {
    setSelectedBrandCodes([]);
    setGlobalFilter('');
    setColumnFilters([]);
    setQuickFilters({ dealerName: '', programLabel: '', stateOrProvince: '' });
  }, []);

  return {
    globalFilter,
    setGlobalFilter,
    columnFilters,
    setColumnFilters,
    quickFilters,
    selectedBrandCodes,
    setSelectedBrandCodes,
    handleQuickFilterChange,
    resetFilters,
  };
};

export default useResultsTableFilters;
